<template>
  <div class="home">
    <div class="box">
      <header class="header">
        <div class="logo">
          <img src="../assets/css/img/logo.png" />
        </div>
        <ul class="ul">
          <li id="home" :class="boolI == 0 ? 'active11' : ''" @click="showI" @mouseenter="hide">{{ $t('home.header1') }}
          </li>
          <li id="fa" :class="boolI == 1 ? 'active11' : ''" @mouseenter="showScenario">{{ $t('home.header2') }}</li>
          <li id="goods" :class="boolI == 2 ? 'active11' : ''" @mouseenter="showG">{{ $t('home.header3') }}</li>
          <!-- <li id="bz" :class="boolI == 3 ? 'active11' : ''" @mouseenter="hide">{{ $t('home.header4') }}</li> -->
          <li id="my" :class="boolI == 4 ? 'active11' : ''" @click="showM" @mouseenter="hide">{{ $t('home.header5') }}</li>
        </ul>
        <p class="language" @click="changeLanguage">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px"
            viewBox="0 0 29 29" style="vertical-align: top;margin-top:2.9rem;">
            <path fill-rule="evenodd" fill="rgb(46, 46, 46)"
              d="M25.553,24.201 C27.862,21.556 29.123,18.206 29.123,14.662 C29.123,10.783 27.613,7.137 24.872,4.394 C22.174,1.693 18.599,0.189 14.789,0.143 C14.727,0.123 14.454,0.124 14.392,0.143 C10.597,0.199 7.038,1.703 4.349,4.394 C1.654,7.091 0.151,10.661 0.101,14.467 C0.087,14.520 0.087,14.746 0.100,14.799 C0.135,18.627 1.641,22.220 4.349,24.930 C7.090,27.673 10.734,29.183 14.611,29.183 C18.487,29.183 22.131,27.673 24.872,24.930 C25.072,24.730 25.264,24.525 25.451,24.316 C25.467,24.301 25.484,24.286 25.499,24.269 C25.519,24.247 25.537,24.224 25.553,24.201 L25.553,24.201 ZM1.446,15.300 L7.543,15.300 C7.586,17.437 7.844,19.441 8.275,21.226 C6.269,21.769 4.996,22.475 4.338,22.915 C2.644,20.809 1.583,18.174 1.446,15.300 L1.446,15.300 ZM4.321,6.429 C4.975,6.870 6.248,7.583 8.267,8.130 C7.845,9.891 7.590,11.864 7.544,13.968 L1.448,13.968 C1.596,11.125 2.649,8.518 4.321,6.429 L4.321,6.429 ZM27.773,13.968 L21.678,13.968 C21.632,11.865 21.377,9.892 20.955,8.132 C22.970,7.588 24.247,6.881 24.908,6.439 C26.576,8.526 27.626,11.130 27.773,13.968 L27.773,13.968 ZM20.346,13.968 L15.257,13.968 L15.257,8.891 C16.954,8.855 18.414,8.681 19.655,8.434 C20.064,10.131 20.301,12.009 20.346,13.968 L20.346,13.968 ZM15.257,7.559 L15.257,1.565 C16.455,1.903 17.623,3.166 18.539,5.145 C18.825,5.764 19.080,6.435 19.302,7.147 C18.163,7.367 16.821,7.524 15.257,7.559 L15.257,7.559 ZM13.925,1.577 L13.925,7.557 C12.380,7.521 11.051,7.362 9.922,7.141 C10.143,6.431 10.397,5.762 10.683,5.145 C11.588,3.188 12.741,1.931 13.925,1.577 L13.925,1.577 ZM13.925,8.890 L13.925,13.968 L8.875,13.968 C8.921,12.009 9.158,10.130 9.566,8.433 C10.797,8.679 12.243,8.853 13.925,8.890 L13.925,8.890 ZM8.874,15.300 L13.925,15.300 L13.925,20.463 C12.247,20.502 10.803,20.677 9.574,20.922 C9.157,19.201 8.917,17.292 8.874,15.300 L8.874,15.300 ZM13.925,21.796 L13.925,27.748 C12.741,27.393 11.588,26.136 10.683,24.179 C10.401,23.569 10.149,22.909 9.930,22.209 C11.056,21.990 12.382,21.833 13.925,21.796 L13.925,21.796 ZM15.257,27.759 L15.257,21.794 C16.814,21.827 18.154,21.985 19.293,22.206 C19.073,22.907 18.821,23.568 18.539,24.179 C17.623,26.158 16.455,27.421 15.257,27.759 L15.257,27.759 ZM15.257,20.461 L15.257,15.300 L20.347,15.300 C20.305,17.288 20.066,19.195 19.650,20.913 C18.411,20.668 16.953,20.496 15.257,20.461 L15.257,20.461 ZM21.679,15.300 L27.776,15.300 C27.639,18.168 26.581,20.798 24.894,22.903 C24.229,22.458 22.955,21.754 20.950,21.215 C21.379,19.433 21.636,17.433 21.679,15.300 L21.679,15.300 ZM24.016,5.431 C23.419,5.808 22.315,6.387 20.606,6.847 C19.978,4.795 19.106,3.105 18.067,1.934 C20.357,2.557 22.400,3.784 24.016,5.431 L24.016,5.431 ZM11.154,1.934 C10.117,3.103 9.246,4.790 8.619,6.838 C6.915,6.374 5.810,5.793 5.218,5.419 C6.832,3.778 8.871,2.556 11.154,1.934 L11.154,1.934 ZM5.233,23.920 C5.828,23.545 6.927,22.969 8.626,22.510 C9.252,24.547 10.121,26.226 11.154,27.390 C8.878,26.770 6.844,25.555 5.233,23.920 L5.233,23.920 ZM18.067,27.390 C19.101,26.225 19.970,24.545 20.597,22.507 C22.287,22.963 23.393,23.536 23.996,23.913 C22.384,25.551 20.347,26.769 18.067,27.390 L18.067,27.390 Z" />
          </svg>
          <span style="font-size:2rem;margin-left:0.5rem">{{ $t('home.language') }}</span>
          <span :class="languageBool ? 'showa' : 'showb'">
            <p @click="changeLanguageZ1">简体中文</p>
            <p @click="changeLanguageE1">English</p>
          </span>
        </p>
        <!-- <p class="login"><span>登 录</span></p> -->
        <ul :class="bool ? 'hide' : 'active'" @mouseleave="showG1">
          <li>
            <div @click="showC">
              <!-- rgba(18,107,242,0.1) -->
              <p class="icon">
                <!-- 唐库收银 -->
                {{ $t('home.product1') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 适用于零售 餐饮 自助服务 多种类型软件 -->
                {{ $t('home.product2') }}
              </p>
            </div>
            <div @click="showK">
              <p class="icon">
                <!-- 唐库厨房 -->
                {{ $t('home.product3') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 专业的后厨人员智能系统 -->
                {{ $t('home.product4') }}
              </p>
            </div>
            <div @click="showU">
              <p class="icon">
                <!-- 唐库辅助工具 -->
                {{ $t('home.product5') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 商品价签设置，批量打印价签，电子秤添加修改 -->
                {{ $t('home.product6') }}
              </p>
            </div>
          </li>
          <li>
            <div @click="showO">
              <p class="icon">
                <!-- 唐库点餐 -->
                {{ $t('home.product7') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 小巧方便的手持设备，收银员点餐好助手 -->
                {{ $t('home.product8') }}
              </p>
            </div>
            <div @click="showS">
              <p class="icon">
                <!-- 唐库盘点器 -->
                {{ $t('home.product9') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 彻底解决门店盘点难题，支持多人盘点 -->
                {{ $t('home.product10') }}
              </p>
            </div>
            <div @click="showA">
              <p class="icon">
                <!-- 唐库商家助手 -->
                {{ $t('home.product11') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 移动商家助手，方便快捷管理门店 -->
                {{ $t('home.product12') }}
              </p>
            </div>
          </li>
        </ul>
        <ul :class="scenario ? 'scenario' : 'active'" @mouseleave="showScenario1">
          <li>
            <div @click="showRepast">
              <p class="icon">
                <!-- 餐饮行业 -->
                {{ $t('home.option1') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 快餐 小吃 咖啡 正餐 酒吧 多种行业 -->
                {{ $t('home.option2') }}
              </p>
            </div>
            <div @click="showFruits">
              <p class="icon">
                <!-- 水果生鲜 -->
                {{ $t('home.option5') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 水果 生鲜 等称重行业 -->
                {{ $t('home.option6') }}
              </p>
            </div>
          </li>
          <li>
            <div @click="showRetail">
              <p class="icon">
                <!-- 零售便利 -->
                {{ $t('home.option3') }}
              </p>
              <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                <!-- 便利店 大型商超 服装店 -->
                {{ $t('home.option4') }}
              </p>
            </div>
          </li>
        </ul>
      </header>
      <section>
        <transition name="fade1">
          <div class="transition-div" v-if="header1">
            <header class="header1">
              <div class="logo">
                <img src="../assets/css/img/logo.png" />
              </div>
              <ul class="ul">
                <li ref="home1" :class="boolI == 0 ? 'active11' : ''" @click="showI" @mouseenter="hide">{{
                  $t('home.header1') }}</li>
                <li ref="fa1" :class="boolI == 1 ? 'active11' : ''" @mouseenter="showScenarioA">{{ $t('home.header2') }}
                </li>
                <li ref="goods1" :class="boolI == 2 ? 'active11' : ''" @mouseenter="showGA">{{ $t('home.header3') }}</li>
                <!-- <li ref="bz1" :class="boolI == 3 ? 'active11' : ''" @mouseenter="hide">{{ $t('home.header4') }}</li> -->
                <li ref="my1" :class="boolI == 4 ? 'active11' : ''" @click="showM" @mouseenter="hide">{{
                  $t('home.header5') }}</li>
              </ul>
              <p class="language" @click="changeLanguage1">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px"
                  height="25px" viewBox="0 0 29 29" style="vertical-align: top;margin-top:2.9rem;">
                  <path fill-rule="evenodd" fill="rgb(46, 46, 46)"
                    d="M25.553,24.201 C27.862,21.556 29.123,18.206 29.123,14.662 C29.123,10.783 27.613,7.137 24.872,4.394 C22.174,1.693 18.599,0.189 14.789,0.143 C14.727,0.123 14.454,0.124 14.392,0.143 C10.597,0.199 7.038,1.703 4.349,4.394 C1.654,7.091 0.151,10.661 0.101,14.467 C0.087,14.520 0.087,14.746 0.100,14.799 C0.135,18.627 1.641,22.220 4.349,24.930 C7.090,27.673 10.734,29.183 14.611,29.183 C18.487,29.183 22.131,27.673 24.872,24.930 C25.072,24.730 25.264,24.525 25.451,24.316 C25.467,24.301 25.484,24.286 25.499,24.269 C25.519,24.247 25.537,24.224 25.553,24.201 L25.553,24.201 ZM1.446,15.300 L7.543,15.300 C7.586,17.437 7.844,19.441 8.275,21.226 C6.269,21.769 4.996,22.475 4.338,22.915 C2.644,20.809 1.583,18.174 1.446,15.300 L1.446,15.300 ZM4.321,6.429 C4.975,6.870 6.248,7.583 8.267,8.130 C7.845,9.891 7.590,11.864 7.544,13.968 L1.448,13.968 C1.596,11.125 2.649,8.518 4.321,6.429 L4.321,6.429 ZM27.773,13.968 L21.678,13.968 C21.632,11.865 21.377,9.892 20.955,8.132 C22.970,7.588 24.247,6.881 24.908,6.439 C26.576,8.526 27.626,11.130 27.773,13.968 L27.773,13.968 ZM20.346,13.968 L15.257,13.968 L15.257,8.891 C16.954,8.855 18.414,8.681 19.655,8.434 C20.064,10.131 20.301,12.009 20.346,13.968 L20.346,13.968 ZM15.257,7.559 L15.257,1.565 C16.455,1.903 17.623,3.166 18.539,5.145 C18.825,5.764 19.080,6.435 19.302,7.147 C18.163,7.367 16.821,7.524 15.257,7.559 L15.257,7.559 ZM13.925,1.577 L13.925,7.557 C12.380,7.521 11.051,7.362 9.922,7.141 C10.143,6.431 10.397,5.762 10.683,5.145 C11.588,3.188 12.741,1.931 13.925,1.577 L13.925,1.577 ZM13.925,8.890 L13.925,13.968 L8.875,13.968 C8.921,12.009 9.158,10.130 9.566,8.433 C10.797,8.679 12.243,8.853 13.925,8.890 L13.925,8.890 ZM8.874,15.300 L13.925,15.300 L13.925,20.463 C12.247,20.502 10.803,20.677 9.574,20.922 C9.157,19.201 8.917,17.292 8.874,15.300 L8.874,15.300 ZM13.925,21.796 L13.925,27.748 C12.741,27.393 11.588,26.136 10.683,24.179 C10.401,23.569 10.149,22.909 9.930,22.209 C11.056,21.990 12.382,21.833 13.925,21.796 L13.925,21.796 ZM15.257,27.759 L15.257,21.794 C16.814,21.827 18.154,21.985 19.293,22.206 C19.073,22.907 18.821,23.568 18.539,24.179 C17.623,26.158 16.455,27.421 15.257,27.759 L15.257,27.759 ZM15.257,20.461 L15.257,15.300 L20.347,15.300 C20.305,17.288 20.066,19.195 19.650,20.913 C18.411,20.668 16.953,20.496 15.257,20.461 L15.257,20.461 ZM21.679,15.300 L27.776,15.300 C27.639,18.168 26.581,20.798 24.894,22.903 C24.229,22.458 22.955,21.754 20.950,21.215 C21.379,19.433 21.636,17.433 21.679,15.300 L21.679,15.300 ZM24.016,5.431 C23.419,5.808 22.315,6.387 20.606,6.847 C19.978,4.795 19.106,3.105 18.067,1.934 C20.357,2.557 22.400,3.784 24.016,5.431 L24.016,5.431 ZM11.154,1.934 C10.117,3.103 9.246,4.790 8.619,6.838 C6.915,6.374 5.810,5.793 5.218,5.419 C6.832,3.778 8.871,2.556 11.154,1.934 L11.154,1.934 ZM5.233,23.920 C5.828,23.545 6.927,22.969 8.626,22.510 C9.252,24.547 10.121,26.226 11.154,27.390 C8.878,26.770 6.844,25.555 5.233,23.920 L5.233,23.920 ZM18.067,27.390 C19.101,26.225 19.970,24.545 20.597,22.507 C22.287,22.963 23.393,23.536 23.996,23.913 C22.384,25.551 20.347,26.769 18.067,27.390 L18.067,27.390 Z" />
                </svg>
                <span style="font-size:2rem;margin-left:0.5rem;">{{ $t('home.language') }}</span>
                <span :class="languageBool1 ? 'showa1' : 'showb1'">
                  <p @click="changeLanguageZ">简体中文</p>
                  <p @click="changeLanguageE">English</p>
                </span>
              </p>
              <!-- <p class="login"><span>登 录</span></p> -->
              <ul :class="bool1 ? 'hide1' : 'active'" @mouseleave="showGA1">
                <li>
                  <div @click="showC">
                    <!-- rgba(18,107,242,0.1) -->
                    <p class="icon">
                      <!-- 唐库收银 -->
                      {{ $t('home.product1') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 适用于零售 餐饮 自助服务 多种类型软件 -->
                      {{ $t('home.product2') }}
                    </p>
                  </div>
                  <div @click="showK">
                    <p class="icon">
                      <!-- 唐库厨房 -->
                      {{ $t('home.product3') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 专业的后厨人员智能系统 -->
                      {{ $t('home.product4') }}
                    </p>
                  </div>
                  <div @click="showU">
                    <p class="icon">
                      <!-- 唐库辅助工具 -->
                      {{ $t('home.product5') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 商品价签设置，批量打印价签，电子秤添加修改 -->
                      {{ $t('home.product6') }}
                    </p>
                  </div>
                </li>
                <li>
                  <div @click="showO">
                    <p class="icon">
                      <!-- 唐库点餐 -->
                      {{ $t('home.product7') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 小巧方便的手持设备，收银员点餐好助手 -->
                      {{ $t('home.product8') }}
                    </p>
                  </div>
                  <div @click="showS">
                    <p class="icon">
                      <!-- 唐库盘点器 -->
                      {{ $t('home.product9') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 彻底解决门店盘点难题，支持多人盘点 -->
                      {{ $t('home.product10') }}
                    </p>
                  </div>
                  <div @click="showA">
                    <p class="icon">
                      <!-- 唐库商家助手 -->
                      {{ $t('home.product11') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 移动商家助手，方便快捷管理门店 -->
                      {{ $t('home.product12') }}
                    </p>
                  </div>
                </li>
              </ul>
              <ul :class="scenario1 ? 'scenario1' : 'active'" @mouseleave="showScenarioA1">
                <li>
                  <div @click="showRepast">
                    <p class="icon">
                      <!-- 餐饮行业 -->
                      {{ $t('home.option1') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 快餐 小吃 咖啡 正餐 酒吧 多种行业 -->
                      {{ $t('home.option2') }}
                    </p>
                  </div>
                  <div @click="showFruits">
                    <p class="icon">
                      <!-- 水果生鲜 -->
                      {{ $t('home.option5') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 水果 生鲜 等称重行业 -->
                      {{ $t('home.option6') }}
                    </p>
                  </div>
                </li>
                <li>
                  <div @click="showRetail">
                    <p class="icon">
                      <!-- 零售便利 -->
                      {{ $t('home.option3') }}
                    </p>
                    <p style="color: #6f6f6f" :class="$i18n.locale == 'en' ? 'active12' : ''">
                      <!-- 便利店 大型商超 服装店 -->
                      {{ $t('home.option4') }}
                    </p>
                  </div>
                </li>
              </ul>
            </header>
          </div>
        </transition>
        <router-view />
      </section>
      <footer>
        <div>
          <div class="footer-content">
            <ul>
              <li class="footer-li">
                <!-- 联系方式 -->
                {{ $t('home.footer1') }}
              </li>
              <li>
                <!-- 地址 : 北京市丰台区南四环西路186号汉威广场一区206室 -->
                {{ $t('home.footer2') }}
              </li>
              <li>
                <!-- 邮箱 : market@xingdata.com -->
                {{ $t('home.footer3') }}
              </li>
              <li>
                <!-- 电话 : 400-800-9406 -->
                {{ $t('home.footer4') }}
              </li>
            </ul>
            <ul>
              <li class="footer-li">
                <!-- 关于我们 -->
                {{ $t('home.footer5') }}
              </li>
              <li>
                <!-- 微信搜索"唐库新零售，或直接扫二维码关注喔~" -->
                {{ $t('home.footer6') }}
              </li>
            </ul>
            <div class="ewm">
              <img src="../assets/css/img/guanzhu.jpg" width="100%">
            </div>
          </div>
          <hr style="margin-top:-2rem;" />
          <div class="footer-bq" style="color: #ffffff; margin-top: 2rem; text-align: center;font-size:1.5rem;">
            &copy; 2013 xingdata.com,all rights reserved 版权所有
            <a href="#" style="color: #117bd5;text-decoration:none;font-size:1.5rem;">京ICP备13031807号</a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      bool: false,// .hide 
      bool1: false,// .hide1
      header: true,// .header
      header1: false,// .header1
      scenario: false,// .scenario
      scenario1: false,// .scenario1
      boolI: "",
      language: '',
      languageBool: false,//header中英文切换
      languageBool1:false,//header1中英文切换
    }
  },
  methods: {
    // 语言切换显示与隐藏
    changeLanguage() {
      // if(this.language=='zh-CN'){
      //   this.language='en';
      //   this.$i18n.locale='en'
      // }else{
      //   this.language='zh-CN'
      //   this.$i18n.locale='zh'
      // }
      this.languageBool = !this.languageBool;
    },
    changeLanguage1(){
      this.languageBool1=!this.languageBool1;
    },
    changeLanguageZ1(){
      this.language='zh-CN';
      this.$i18n.locale='zh';
      this.languageBool1=false;
      // localStorage.setItem('locale','https://mer.51zzd.com/user/login')
    },
    changeLanguageE1(){
      this.language='en';
      this.$i18n.locale='en';
      this.languageBool1=false;
    },
    changeLanguageZ() {
      this.language = 'zh-CN';
      this.$i18n.locale = 'zh';
      this.languageBool = false;
      // localStorage.setItem('locale','https://mer.51zzd.com/user/login')
    },
    changeLanguageE() {
      this.language = 'en';
      this.$i18n.locale = 'en';
      this.languageBool = false;
    },
    hide() {
      this.bool = false;
      this.bool1 = false;
      this.scenario = false;
      this.scenario1 = false;
    },
    showRetail() {
      this.$router.push({ path: '/retail' });
      this.scenario1 = false;
      this.scenario = false;
      this.boolI = 1;

    },
    showFruits() {
      this.$router.push({ path: '/fruits' });
      this.scenario1 = false;
      this.scenario = false;
      this.boolI = 1;
    },
    showRepast() {
      this.$router.push({ path: '/repast' });
      this.scenario1 = false;
      this.scenario = false;
      this.boolI = 1;
    },
    showI() {
      this.$router.push({ path: '/index' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 0;
    },
    showM() {
      this.$router.push({ path: '/aboutus' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 4;
    },
    showA() {
      this.$router.push({ path: '/assistant' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showS() {
      this.$router.push({ path: '/stock' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showO() {
      this.$router.push({ path: '/order' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showU() {
      this.$router.push({ path: '/utility' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showK() {
      this.$router.push({ path: '/kitchen' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showC() {
      this.$router.push({ path: '/cash' })
      this.bool1 = false;
      this.bool = false;
      this.boolI = 2;
    },
    showScenario1() {
      this.scenario = false;
    },
    showScenario() {
      this.scenario = true;
      this.bool = false;
    },
    showScenarioA() {
      this.scenario1 = true;
      this.bool1 = false;
    },
    showScenarioA1() {
      this.scenario1 = false;
    },
    showG() {
      this.bool = true;
      this.scenario = false;
    },
    showG1() {
      this.bool = false;
    },
    showGA() {
      this.bool1 = true;
      this.scenario1 = false;
    },
    showGA1() {
      this.bool1 = false;
    },
    showN() {
      let top = document.documentElement.scrollTop;
      if (top >= 80) {
        this.header = false;
        this.header1 = true;
      } else {
        this.header = true;
        this.header1 = false;
      }
    }
  },
  mounted() {
    // console.log(navigator.language);
    this.language = navigator.language;
    if (this.language == 'zh-CN') {
      localStorage.setItem('language', 'zh')
      this.$i18n.locale == 'zh';
    } else {
      localStorage.setItem('language', 'en')
      this.$i18n.locale == 'en';
    }
    window.addEventListener("scroll", this.showN, true);
    document.title = '唐库';
    let route = this.$route.path;
    if (route == '/index') {
      this.boolI = 0;
    } else if (route == '/cash' || route == '/order' || route == '/kitchen' || route == '/assistant' || route == '/stock' || route == '/utility') {
      this.boolI = 2;
    } else if (route == '/fruits' || route == '/repast' || route == '/retail') {
      this.boolI = 1;
    } else {
      this.boolI = 4;
    }
  }
}
</script>
<style lang="less" scoped>
.showa {
  display: block;
  width: 10rem;
  height: 8rem;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  position: absolute;
  left: 2rem;
  top: 7.8rem;
  z-index: 666;
  line-height: 4rem;
  text-align: center;
  font-size: 1.8rem;
  p:hover{
    font-weight:700;
  }
}

.showb {
  display: none;
}
.showa1 {
  display: block;
  position: absolute;
  width: 10rem;
  height: 8rem;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  left: 2rem;
  top: 7.8rem;
  z-index: 666;
  line-height: 4rem;
  text-align: center;
  font-size: 1.8rem;
  p:hover{
    font-weight:700;
  }
}

.showb1 {
  display: none;
}
.active12 {
  font-size: 1.4rem;
}

.active11 {
  border-bottom: solid 2px #4591fe;
  font-weight: 700;
}

.box {
  width: 100%;
  height: 100%;
}

.transition-div {
  width: 100%;
  height: 80px;
  background: #FFFFFF;
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 0px;
  // border-bottom:solid 1px;
  box-shadow: 0px 0px 0px 2px #F2F2F2;
  // text-align: center;
  z-index: 222;
}

.header1 {
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 0px;
  z-index: 666;
  width: 120rem;
  height: 8rem;
  background: #ffffff;
  display: flex;
  margin: 0 auto;
  box-shadow: 0px 0px 0px 0px #d2d2d2;
  border-top: solid 1px #ffffff;


  .logo {
    margin-left: 10rem;
    margin-top: 1.5rem;
    width: 20rem;
    height: 8rem;

    img {
      width: 20rem;
    }
  }

  .ul {
    display: flex;
    justify-content: space-between;
    width: 50rem;
    margin-left: 7rem;

    li {
      line-height: 8rem;
      height: 8rem;
      font-size: 2rem;
    }

    li:hover {
      font-weight: 700;
      border-bottom: solid 2px #4591fe;
    }
  }
  .language {
    position:relative;
    margin-left: 5rem;
    // margin-top: 3rem;
    height: 8rem;
    line-height: 8rem;
    font-size: 1.8rem;
  }

  .login {
    margin-left: 4rem;
    margin-top: 2.2rem;
    width: 10rem;
    height: 3.5rem;
    background: #4591fe;
    border: solid 1px #4591fe;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-family: Microsoft YaHei;
      text-align: center;
      font-weight: 400;
      font-size: 1.8rem;
      color: #fff;
    }
  }
}

.fade1-enter-active,
.fade1-leave-active {
  transition: opacity .5s;
}

.fade1-enter,
.fade1-leave-to {
  opacity: 0;
}

footer {
  width: 100%;
  background: #1b242c;
}

footer>div {
  width: 120rem;
  height: 27rem;
  margin: 0 auto;
  background: #1b242c;
  padding-top: 3.5rem;

  // padding-left: 12.5rem;
  // padding-right: 12.5rem;
  // box-sizing: border-box;
  .footer-content {
    display: flex;
    justify-content: center;
    // padding-left:1rem;

    ul {
      width: 52rem;
      height: 20rem;
      color: #ffffff;
      margin-right: 5rem;

      li {
        margin-top: 1.5rem;
        font-size: 1.6rem;
      }

      .footer-li {
        font-weight: 700;
        font-size: 2.5rem;
        margin-bottom: 1rem;
      }
    }

    ul+ul {
      width: 40rem;
    }

    .ewm {
      width: 15rem;
      padding-top: 1rem;
      // margin-left:-5rem;
    }
  }
}

.header {
  width: 120rem;
  height: 8rem;
  background: #ffffff;
  display: flex;
  margin: 0 auto;
  box-shadow: 0px 0px 0px 0px #d2d2d2;
  border-top: solid 1px #ffffff;
  position: relative;

  .logo {
    margin-left: 10rem;
    margin-top: 1.5rem;
    width: 20rem;
    height: 8rem;

    img {
      width: 20rem;
    }
  }

  .ul {
    display: flex;
    justify-content: space-between;
    width: 50rem;
    margin-left: 7rem;

    li {
      // margin-top: 3rem;
      line-height: 8rem;
      height: 8rem;
      font-size: 2rem;
    }

    li:hover {
      font-weight: 700;
      border-bottom: solid 2px #4591fe;
    }

    #goods:hover {
      font-weight: 700;
      border-bottom: none;
    }
  }

  .language {
    position: relative;
    margin-left: 5rem;
    height: 8rem;
    line-height: 8rem;
    font-size: 1.8rem;
  }

  .login {
    margin-left: 4rem;
    margin-top: 2.2rem;
    width: 10rem;
    height: 3.5rem;
    background: #4591fe;
    border: solid 1px #4591fe;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-family: Microsoft YaHei;
      text-align: center;
      font-weight: 400;
      font-size: 1.8rem;
      color: #fff;
    }
  }
}
@media screen and (max-width:1300px) {
  .box {
    overflow: hidden;
  }
}

@media screen and (max-width:449px) {
  .header {
    .ul {
      display: none;
    }
  }

  .language {
    display: none;
  }
}

.hide {
  display: block;
  width: 80rem;
  height: 35rem;
  position: absolute;
  // border: solid 1px #f2f2f2;
  border: 1px solid #EEEEEE;
  border-top: 2px solid #4591fe;
  background: #fff;
  top: 7.8rem;
  left: 13rem;
  display: flex;
  justify-self: space-between;
  margin: 0;
  z-index: 999;

  li {
    flex: 0 1 50%;
    width: 100%;

    div {
      height: 11.6rem;
      padding-left: 5rem;
      padding-top: 3.5rem;
      // line-height:8rem;
      box-sizing: border-box;
      font-size: 1.6rem;

      .icon {
        margin-bottom: 0.5rem;
      }
    }

    div:hover .icon {
      font-weight: 700;
    }

    div:hover {
      background: rgba(18, 107, 242, 0.1);
    }
  }
}

//方案场景
.scenario {
  display: block;
  width: 80rem;
  height: 23.4rem;
  position: absolute;
  // border: solid 1px #f2f2f2;
  border: 1px solid #EEEEEE;
  border-top: 2px solid #4591fe;
  background: #fff;
  top: 7.8rem;
  left: 10rem;
  display: flex;
  justify-self: space-between;
  margin: 0;
  z-index: 999;

  li {
    flex: 0 1 50%;
    width: 100%;

    div {
      height: 11.6rem;
      padding-left: 5rem;
      padding-top: 3.5rem;
      box-sizing: border-box;
      font-size: 1.6rem;

      .icon {
        margin-bottom: 0.5rem;
      }
    }

    div:hover .icon {
      font-weight: 700;
    }

    div:hover {
      background: rgba(18, 107, 242, 0.1);
    }
  }
}

.hide1 {
  display: block;
  width: 80rem;
  height: 35rem;
  position: absolute;
  // border: solid 1px #f2f2f2;
  border: 1px solid #EEEEEE;
  border-top: 2px solid #4591fe;
  background: #fff;
  top: 7.8rem;
  left: 13rem;
  display: flex;
  justify-self: space-between;
  margin: 0;
  z-index: 999;

  li {
    flex: 0 1 50%;
    width: 100%;

    div {
      height: 11.6rem;
      padding-left: 5rem;
      padding-top: 3.5rem;
      box-sizing: border-box;
      font-size: 1.6rem;

      .icon {
        margin-bottom: 0.5rem;
      }
    }

    div:hover .icon {
      font-weight: 700;
    }

    div:hover {
      background: rgba(18, 107, 242, 0.1);
    }
  }
}

.scenario1 {
  display: block;
  width: 80rem;
  height: 23.4rem;
  position: absolute;
  // border: solid 1px #f2f2f2;
  border: 1px solid #EEEEEE;
  border-top: 2px solid #4591fe;
  background: #fff;
  top: 7.8rem;
  left: 10rem;
  display: flex;
  justify-self: space-between;
  margin: 0;
  z-index: 999;

  li {
    flex: 0 1 50%;
    width: 100%;

    div {
      height: 11.6rem;
      padding-left: 5rem;
      padding-top: 3.5rem;
      box-sizing: border-box;
      font-size: 1.6rem;

      .icon {
        margin-bottom: 0.5rem;
      }
    }

    div:hover .icon {
      font-weight: 700;
    }

    div:hover {
      background: rgba(18, 107, 242, 0.1);
    }
  }
}

@media screen and (max-width:1200px) {
  .header {
    width: 100%;
    height: 8rem;
    background: #ffffff;
    display: flex;
    margin: 0 auto;
    box-shadow: 0px 0px 0px 0px #d2d2d2;
    border-top: solid 1px #ffffff;
    position: relative;

    .logo {
      margin-left: 1rem;
      margin-top: 1.5rem;
      width: 20rem;
      height: 8rem;

      img {
        width: 20rem;
      }
    }

    .ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 60rem;
      margin-left: 4rem;

      li {
        // margin-top: 30px;
        // height: 45px;
        line-height: 8rem;
        height: 8rem;
        font-size: 1.6rem;

      }

      li:hover {
        font-weight: 700;
        border-bottom: solid 2px #4591fe;
      }
    }

    .language {
      margin-left: 3rem;
      height: 8rem;
      line-height: 8rem;
      font-size: 1.6rem;
    }

    .login {
      margin-left: 4rem;
      margin-top: 2.2rem;
      width: 10rem;
      height: 3.5rem;
      background: #4591fe;
      border: solid 1px #4591fe;
      border-radius: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;

      span {
        font-family: Microsoft YaHei;
        text-align: center;
        color: #fff;
      }
    }
  }

  .header1 {
    position: fixed;
    left: 50%;
    transform: translate(-50%);
    top: 0rem;
    width: 100%;
    height: 8rem;
    background: #ffffff;
    display: flex;
    margin: 0 auto;
    box-shadow: 0px 0px 1px 0px #d2d2d2;
    border-top: solid 1px #ffffff;
    position: relative;

    .logo {
      margin-left: 1rem;
      margin-top: 1.5rem;
      width: 20rem;
      height: 8rem;

      img {
        width: 20rem;
      }
    }

    .ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 60rem;
      margin-left: 4rem;

      li {
        // margin-top: 30px;
        // height: 45px;
        line-height: 8rem;
        height: 8rem;
        font-size: 1.6rem;

      }

      li:hover {
        font-weight: 700;
        border-bottom: solid 2px #4591fe;
      }
    }

    .language {
      margin-left: 3rem;
      height: 8rem;
      line-height: 8rem;
      font-size: 1.6rem;
    }

    .login {
      margin-left: 4rem;
      margin-top: 2.2rem;
      width: 10rem;
      height: 3.5rem;
      background: #4591fe;
      border: solid 1px #4591fe;
      border-radius: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.6rem;

      span {
        font-family: Microsoft YaHei;
        text-align: center;
        color: #fff;
      }
    }
  }

  .hide {
    overflow: hidden;
    display: block;
    width: 70%;
    height: 350px;
    position: absolute;
    border: solid 1px #f2f2f2;
    border-top: 2px solid #4591fe;
    background: #fff;
    top: 7.8rem;
    left: 20%;
    display: flex;
    justify-self: space-between;
    margin: 0;
    z-index: 999;

    li {
      flex: 0 1 50%;
      width: 100%;

      div {
        height: 116px;
        padding-left: 0, 3%;
        padding-top: 35px;
        box-sizing: border-box;

        .icon {
          margin-bottom: 5px;
        }
      }

      div:hover .icon {
        font-weight: 700;
      }

      div:hover {
        background: rgba(18, 107, 242, 0.1);
      }
    }
  }

  .hide1 {
    overflow: hidden;
    display: block;
    width: 70%;
    height: 35rem;
    position: absolute;
    border: solid 1px #f2f2f2;
    border-top: 2px solid #4591fe;
    background: #fff;
    top: 7.8rem;
    left: 20%;
    display: flex;
    justify-self: space-between;
    margin: 0;
    z-index: 999;

    li {
      flex: 0 1 50%;
      width: 100%;

      div {
        height: 116px;
        padding-left: 0, 3%;
        padding-top: 35px;
        box-sizing: border-box;

        .icon {
          margin-bottom: 5px;
        }
      }

      div:hover .icon {
        font-weight: 700;
      }

      div:hover {
        background: rgba(18, 107, 242, 0.1);
      }
    }
  }
}

.active {
  display: none;

}

@media screen and (max-width:1154px) {
  .language {
    margin-left: 3rem;
    height: 8rem;
    line-height: 8rem;
    font-size: 1.6rem;
  }
}

@media screen and (max-width:376px) {
  .box {
    width: 100%;
    height: 100%;


  }

  .fade1-enter-active,
  .fade1-leave-active {
    transition: opacity .5s;
  }

  .fade1-enter,
  .fade1-leave-to {
    opacity: 0;
  }

  footer {
    width: 100%;
    background: #1b242c;
  }

  footer>div {
    width: 100%;
    height: 250px; //615
    margin: 0 auto;
    background: #1b242c;
    padding-left: 10%;
    padding-right: 15%;
    box-sizing: border-box;

    .footer-content {
      display: flex;
      justify-content: center;

      ul {
        width: 50%;
        height: 20%;
        color: #ffffff;

        li {
          margin-top: 15px;
        }

        .footer-li {
          font-weight: 700;
          font-size: 25px;
          margin-bottom: 35px;
        }
      }

      ul+ul {
        width: 41%;
      }

      .ewm {
        width: 16%;
      }
    }
  }
}</style>